/**
 * @file Recettes de synthese des effets sonores (WebAudio, aucun fichier audio) interpretees par platform/audio/AudioEngine.
 */
import type { SfxId, SfxRecipe } from './types';

const r = (
  id: SfxId,
  wave: SfxRecipe['wave'],
  f0: number,
  f1: number,
  duration: number,
  gain: number,
  extra: Partial<SfxRecipe> = {},
): SfxRecipe => ({ id, wave, freq: [f0, f1], duration, gain, ...extra });

export const SFX_RECIPES: Record<SfxId, SfxRecipe> = {
  pop: r('pop', 'sine', 520, 880, 0.08, 0.25),
  button: r('button', 'triangle', 660, 520, 0.06, 0.2),
  spawn: r('spawn', 'sine', 300, 600, 0.12, 0.15),
  fusion: r('fusion', 'square', 330, 990, 0.35, 0.22, { chord: [0, 4, 7, 12] }),
  upgrade: r('upgrade', 'triangle', 440, 880, 0.14, 0.25),
  rebirth: r('rebirth', 'sawtooth', 110, 880, 1.0, 0.2, { chord: [0, 7, 12, 19], filterHz: 2400 }),
  purchase: r('purchase', 'square', 880, 1320, 0.16, 0.18, { chord: [0, 7] }),
  shoot: r('shoot', 'square', 900, 240, 0.07, 0.1, { filterHz: 3200 }),
  shootHeavy: r('shootHeavy', 'sawtooth', 300, 60, 0.18, 0.16, { filterHz: 1400 }),
  hit: r('hit', 'noise', 800, 400, 0.05, 0.12, { filterHz: 2000 }),
  crit: r('crit', 'square', 1200, 600, 0.1, 0.16, { chord: [0, 12] }),
  treeFall: r('treeFall', 'noise', 600, 120, 0.3, 0.2, { filterHz: 900 }),
  explosion: r('explosion', 'noise', 500, 40, 0.45, 0.28, { filterHz: 700 }),
  coin: r('coin', 'square', 1320, 1760, 0.07, 0.1),
  win: r('win', 'triangle', 523, 1046, 0.6, 0.25, { chord: [0, 4, 7, 12] }),
  fail: r('fail', 'sawtooth', 330, 110, 0.5, 0.22, { filterHz: 1200 }),
  tick: r('tick', 'square', 1000, 1000, 0.03, 0.08),
  starSuccess: r('starSuccess', 'triangle', 660, 1320, 0.5, 0.25, { chord: [0, 4, 7, 12, 16] }),
  starFail: r('starFail', 'sawtooth', 220, 80, 0.4, 0.2, { filterHz: 900 }),
  gacha: r('gacha', 'sine', 300, 1200, 0.5, 0.22, { chord: [0, 7] }),
  levelUp: r('levelUp', 'triangle', 392, 784, 0.3, 0.25, { chord: [0, 4, 7] }),
  monsterDie: r('monsterDie', 'sine', 400, 100, 0.15, 0.18),
  barrierHit: r('barrierHit', 'sawtooth', 150, 60, 0.2, 0.25, { filterHz: 800 }),
};
